import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";
import { MS_5_MINUTES } from "../../defines";
import { logError } from "../../../../helpers/src/errors/logError";

export const CORE_USER_SETTINGS_QUERY_KEY = ["core-user-settings"];

/**
 * Fetches the authenticated user's settings from `/v1/settings/user`
 * (design system, notification settings, week start override, ...).
 */
export const useCoreUserSettings = ({
  disabled = false
}: { disabled?: boolean } = {}) => {
  const { apiClient } = useTacticHooks();

  return useQuery({
    queryKey: CORE_USER_SETTINGS_QUERY_KEY,
    queryFn: async () => {
      try {
        const data = await apiClient.userSettings.getCoreUserSettings();
        if (data.ok && data.result) {
          return data.result;
        }
        throw data;
      } catch (error) {
        logError("Error fetching user settings", error);
        throw error;
      }
    },
    enabled: !disabled,
    staleTime: MS_5_MINUTES
  });
};
